import type { Directive } from "vue";

const autofocus: Directive = {
  mounted(el, binding) {
    // If directive has bound value
    if (binding.value !== undefined && !binding.value) {
      return;
    }

    // Focus the element
    el.focus();
  }
};

export default autofocus;
